import {React, FC, useContext} from 'external/react'
import { TeacherContext } from 'teacher/context'
import StyledTopbarButton from './StyledTopbarButton'

const CancelPlan:FC<Partial<typeof StyledTopbarButton>> = (props) => {
  const {translate, navigate, newPlanFrom, newPlanFromQuery} = useContext(TeacherContext) as any
  return (
    <StyledTopbarButton variant="contained" onClick={() => { navigate({view: newPlanFrom},'/:languageId/:role/:page/:view',{query: newPlanFromQuery})}} {...props}>
      {translate("cancel_label")}
    </StyledTopbarButton>
  )
}

export {CancelPlan as default}